/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
};

(function () {
  BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
      if (document.readyState === "complete") {
        resolve(document);
      } else {
        document.addEventListener("DOMContentLoaded", function () {
          resolve(document);
        });
      }
    });
  };

  document.ready().then(function () {
    var inputSearchFormSelector = jQ(".boost-pfs-search-input");
    var clearSearchFormSelector = jQ(".boost-pfs-search-form-btn-clear");

    if (!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }

    inputSearchFormSelector.on("change keydown keyup", function () {
      if (!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    });

    clearSearchFormSelector.on("click", function () {
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  }); // End Clear button for the Form Search

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function () {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile =
      ".site-nav--mobile .search-button, .js-search-destop";
    var searchInputMobile =
      '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = ".drawer__close > button, .drawer_back a";
    jQ(searchButtonMobile)
      .off("click")
      .click(function (e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ(searchInputMobile).focus();
        self.openSuggestionMobile();
        jQ(searchCloseButtonMobile).trigger("click");
      });
  };

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function () {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = ".site-header__links .search-button";
    var searchInputDesktop = "#SearchContainer #search-input";
    var searchCloseButtonDesktop = ".drawer__close > button";
    jQ(searchButtonDesktop)
      .off("click")
      .click(function (e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ(searchInputDesktop).focus();
        self.openSuggestionStyle3();
        jQ(searchCloseButtonDesktop).trigger("click");
      });
  };

  // Fix search for the Flow theme
  jQ(".site-header__links .search-button").on("click", function () {
    setTimeout(function () {
      boostPFS.initSearchBox();
      if (Utils.isCollectionPage())
        jQ(".search-input-group > .boost-pfs-search-box").val("");
    }, 500);
  });

  Utils.buildProductItemUrl = function (data, hasCollection) {
    // Get url information
    var params = Utils.getWindowLocation().search.substring(1);
    var pathname = window.location.pathname;
    var elements = pathname.split("/");

    // Check if has locale
    var localeURLPart = "";
    var hasShopifyRoutes =
      Shopify && Shopify.routes && typeof Shopify.routes.root != "undefined";
    if (
      Settings.getSettingValue("general.useShopifyRouteForMultiLanguageURL") &&
      hasShopifyRoutes
    ) {
      localeURLPart = Shopify.routes.root.replace(/\/$/, "");
    } else if (
      elements.indexOf(boostPFSAppConfig.general.current_locale) > -1
    ) {
      localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    }

    // Get product handle
    var handle =
      typeof data === "object" && data.hasOwnProperty("handle")
        ? data.handle
        : data;
    var hasCollection =
      typeof hasCollection !== "undefined"
        ? hasCollection
        : Settings.getSettingValue("general.addCollectionToProductUrl");
    // jdp: removed collection path from product links
    if (false /*hasCollection*/) {
      // Homepage or Search page
      if (
        pathname == "/" ||
        Utils.isSearchPage() ||
        Utils.isVendorPage() ||
        Utils.isTypePage()
      ) {
        var preHandle = localeURLPart + "/collections/all/products/";
        return preHandle + handle;

        // Tag Page
      } else if (Utils.isTagPage()) {
        var preHandle = localeURLPart + "/collections/";
        var collectionHandleIndex = elements.indexOf("collections") + 1;
        if (elements.length >= 4)
          return (
            preHandle + elements[collectionHandleIndex] + "/products/" + handle
          );
        return "/collections/all/products/" + handle;
      } else {
        // Google cache URL
        // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
        if (params.indexOf("cache:") > -1) {
          var collectionHandle = "all";
          var temp = params.split("&")[0].split("?")[0].split("collections/");
          if (temp.length > 1) {
            if (temp[1].indexOf("/") > -1) {
              collectionHandle = temp[1].split("/")[0];
            } else {
              collectionHandle = temp[1];
            }
          }
          collectionHandle = collectionHandle.replace(
            /[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g,
            ""
          );
          return "/collections/" + collectionHandle + "/products/" + handle;
        }
        var collectionHandleIndex = elements.indexOf("collections") + 1;
        var preHandle = localeURLPart + "/collections/";

        if (typeof elements[2] !== "undefined") {
          // Build for collection pages
          if (
            (localeURLPart == "" && elements[1] === "collections") ||
            localeURLPart != ""
          ) {
            return (
              preHandle +
              elements[collectionHandleIndex] +
              "/products/" +
              handle
            );
          }
          //Build for other pages, use collection/all
          return (
            preHandle +
            "all" +
            elements[collectionHandleIndex] +
            "/products/" +
            handle
          );
        } else if (typeof elements[2] === "undefined" && localeURLPart == "") {
          return "/products/" + handle;
        }
        return window.location.pathname + "/products/" + handle;
      }
    }
    return localeURLPart + "/products/" + handle;
  };

  SearchAutoComplete.prototype._onKeyboardEnter = function(e) {
		if (this._isXSSSearchTerm()) return;

		if (!this.isOpen || !this.$element || !e || !e.key) return;
		var isStopPropagation = false;
		if (e.key == "Enter" || e.key == "Space") {
			if (this.keyboardNavIndex != -1 && this.$keyboardSelectedItem) {
				var link = this.$keyboardSelectedItem.find('a').attr('href');
				if (link && !Utils.isBadUrl(link)) {
					isStopPropagation = true;
					window.location.href = link;
				}
			} else {
        // Fix: Customize redirect
      	if(e.key == "Enter"){
          
          const result = Globals?.suggestionCache[Globals?.currentTerm] || [];
          const redirectURL = result.filter(item => item.key === 'redirect')?.[0]?.values;
					if(redirectURL) {
            isStopPropagation = true;
            window.location.href = redirectURL
          }
        }
        // End Fix: Customize redirect
      }
		} else if (e.key == "Tab") {
			if (document.activeElement) {
				if (document.activeElement.id != this.searchInput.id) {
					this._onClose();
				} else {
					this._onOpen();
				}
			}
		} else if (e.key == "Escape") {
			this._onClose();
		}
		if (isStopPropagation) {
			e.stopImmediatePropagation();
			e.stopPropagation();
			e.preventDefault();
		}
	};

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        // Fix price
        var availableVariants = this.data.variants.filter(v => v.available).sort((a,b) => parseFloat(a.price) - parseFloat(b.price));
        if (availableVariants.length > 0) {
          this.data.price_min = availableVariants[0].price / 1;
          this.data.compare_at_price_min = availableVariants[0].compare_at_price / 1;
        }
    
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
	}
  
})();
